import { get as getBrowse } from "#skyward_browse";
import { processViewPartHtml, virtualDir } from "#skyward_global";
import { showInformationBubble } from "#skyward_modalLayer";
import { loadContent } from "#skyward_window";
import { registerEvents } from "./skyward.ui.events";
import { JQueryInput } from "./types";

const classes =
{
    existsAsFavorite: "existsAsFavorite"
};

const dataAttributes =
{
    favoriteId: "favorite-id"
};

registerEvents("favorites",
    {
        openMenu,
        addOrRemoveFavorite,
        edit
    }
);

function openMenu(this: JQueryInput)
{
    const clickedElement = $(this);

    return buildPopup()
        .done(async function (data)
        {
            const content = data.content.Content;
            const processedFooter = await processViewPartHtml(data.footer.Content);
            const dialog = showInformationBubble("Favorites", content, undefined, { anchorTo: clickedElement, useSmallWidth: true });
            dialog.container.append(processedFooter);
        });
}

function edit(this: JQueryInput)
{
    return loadContent("full", "SkySys", "UserFavorite", "List", null);
}

function addOrRemoveFavorite(this: JQueryInput)
{
    const favoriteSelector = $(this);
    if (favoriteSelector.hasClass(classes.existsAsFavorite))
    {
        const id = favoriteSelector.data(dataAttributes.favoriteId);

        return deleteThisFavorite(id!)
            .done(function ()
            {
                toggleFavoritesSelectorAction(favoriteSelector, false, id!, window.location.href);
            });
    }

    return addFavorite()
        .done(function (data)
        {
            if (!data.alreadyExists)
            {
                toggleFavoritesSelectorAction(favoriteSelector, true, data.id, window.location.href);
            }
        });
}

function addFavorite()
{
    return $.ajax({
        url: `${virtualDir}SkySys/UserFavorite/AddFavorite`,
        type: "POST",
        dataType: "JSON",
        data: { ScreenFriendlyName: $("#friendlyNameContents").text() }
    });
}

function deleteThisFavorite(id: string)
{
    return $.ajax({
        url: `${virtualDir}SkySys/UserFavorite/DeleteFavorite`,
        type: "POST",
        dataType: "JSON",
        data: { id }
    });
}

function buildPopup()
{
    return $.ajax({
        url: `${virtualDir}SkySys/UserFavorite/PopulateFavorites/`,
        type: "POST",
        dataType: "JSON"
    });
}

function toggleFavoritesSelectorAction(favoriteSelector: JQuery<HTMLElement>, canAddFavorite: boolean, id: string, location: string)
{
    if (canAddFavorite)
    {
        favoriteSelector.addClass(classes.existsAsFavorite);
        favoriteSelector.data(dataAttributes.favoriteId, id);
        favoriteSelector.attr("aria-label", "Remove Favorite");
    }
    else
    {
        favoriteSelector.removeClass(classes.existsAsFavorite);
        favoriteSelector.removeData(dataAttributes.favoriteId);
        favoriteSelector.attr("aria-label", "Add Favorite");
    }

    if (location.includes("SkySys/UserFavorite/List"))
    {
        getBrowse("browse");
    }
}
